export default __webpack_public_path__ + "static/media/ss2016-11-18at03_04_37.2c8e94ff.jpg";